export default abstract class PrimitiveValueObject<T, TPrimitive, TJSON> {
  abstract value: TPrimitive;

  protected constructor(_: TPrimitive) {};

  abstract toJSON(): TJSON;
  abstract isEqualTo(other: T | null | undefined): boolean;
  abstract toString(): string;
  abstract valueOf(): TPrimitive;
}